import React from "react";
import {
  FaHospital,
  FaDollarSign,
  FaUserMd,
  FaClock,
  FaGlobe,
  FaBriefcaseMedical,
  FaClipboardList,
  FaHeadset,
  FaPlane,
  FaFileMedical,
  FaHandshake,
  FaSyringe,
} from "react-icons/fa";

const cardData = [
  {
    icon: <FaHospital />,
    title: "Advanced Medical Facilities",
    description:
      "Access to state-of-the-art hospitals and cutting-edge medical technology worldwide.",
  },
  {
    icon: <FaDollarSign />,
    title: "Cost-Effective Treatment",
    description:
      "Save up to 70% on medical procedures without compromising on quality and safety.",
  },
  {
    icon: <FaUserMd />,
    title: "Expert Medical Professionals",
    description:
      "Connect with internationally trained doctors and specialists in various medical fields.",
  },
  {
    icon: <FaClock />,
    title: "Reduced Waiting Times",
    description:
      "Skip long queues and get immediate access to medical consultations and procedures.",
  },
  {
    icon: <FaGlobe />,
    title: "Global Healthcare Network",
    description:
      "Access healthcare services across multiple countries and medical destinations.",
  },
  {
    icon: <FaBriefcaseMedical />,
    title: "Comprehensive Care Packages",
    description:
      "All-inclusive medical tourism packages covering treatment, accommodation, and travel.",
  },
  {
    icon: <FaClipboardList />,
    title: "Personalized Treatment Plans",
    description:
      "Customized medical solutions tailored to your specific health needs and preferences.",
  },
  {
    icon: <FaHeadset />,
    title: "24/7 Patient Support",
    description:
      "Round-the-clock assistance and coordination throughout your medical journey.",
  },
  {
    icon: <FaPlane />,
    title: "Travel & Accommodation",
    description:
      "Seamless travel arrangements and comfortable accommodation near medical facilities.",
  },
  {
    icon: <FaFileMedical />,
    title: "Medical Records Management",
    description:
      "Secure digital management and transfer of medical records and documentation.",
  },
  {
    icon: <FaHandshake />,
    title: "Accredited Healthcare Partners",
    description:
      "Partnership with internationally accredited hospitals and healthcare institutions.",
  },
  {
    icon: <FaSyringe />,
    title: "Specialized Treatments",
    description:
      "Access to rare procedures and specialized treatments not available locally.",
  },
];

const steps = [
  {
    step: "1",
    title: "Initial Consultation",
    description:
      "Free consultation to understand your medical needs and recommend suitable treatment options.",
  },
  {
    step: "2",
    title: "Medical Evaluation",
    description:
      "Comprehensive review of medical records and virtual consultation with specialists.",
  },
  {
    step: "3",
    title: "Treatment Planning",
    description:
      "Customized treatment plan with detailed cost breakdown and timeline.",
  },
  {
    step: "4",
    title: "Travel Arrangements",
    description:
      "Complete travel coordination including visa, flights, and accommodation booking.",
  },
  {
    step: "5",
    title: "Medical Treatment",
    description:
      "Receive world-class treatment with dedicated care coordination and support.",
  },
  {
    step: "6",
    title: "Recovery & Follow-up",
    description:
      "Post-treatment care, recovery support, and ongoing medical follow-up.",
  },
];
const BootstrapCardGrid = () => {
  return (
    <div
      className="container py-5"
      style={{
        background: "linear-gradient(to bottom right, #ffffffff, #ffffffff)",
        borderRadius: "18px",
      }}
    >
      <div className="row g-4">
        {cardData.map((card, index) => (
          <div className="col-12 col-sm-6 col-lg-4" key={index}>
            <div
              className="service-item-2 fade-top card h-100 shadow rounded-4 text-center p-3 border-0"
              style={{
                background:
                  "linear-gradient(180deg, #E2EEFF 0%, rgba(255, 255, 255, 0) 50%)",
              }}
            >
              <div
                className="icon mx-auto mb-3 d-flex align-items-center justify-content-center "
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  width: "70px",
                  height: "70px",
                  // fontSize: "1.5rem",
                  color: "#276CF5",
                }}
              >
                {card.icon ? (
                  card.icon
                ) : (
                  <img
                    src={card.iconSrc}
                    alt="icon"
                    style={{ width: "40px", height: "40px" }}
                  />
                )}
              </div>
              <div className="card-body px-2 content">
                <h5 className="card-title fw-semibold title">
                  <a
                    href={card.link || "#"}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {card.title}
                  </a>
                </h5>
                <p className="card-text text-muted small">{card.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BootstrapCardGrid;

// const   BootstrapCardGrid = () => {
//   return (
//     <div className="container py-5" style={{ background: "linear-gradient(to bottom right, #aabbfcff, #49648bff)" ,borderRadius:"18px"}}>
//       <div className="row g-4">
//         {cardData.map((card, index) => (
//           <div className="col-12 col-sm-6 col-lg-4" key={index}>
//             <div className="card h-100 shadow rounded-4 text-center p-3 border-0">
//               <div
//                 className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-4"
//                 style={{
//                   background: "linear-gradient(to right, #080ce7, #185ec8)",
//                   width: "60px",
//                   height: "60px",
//                   fontSize: "1.5rem",
//                   color: "#fff",
//                 }}
//               >
//                 {card.icon}
//               </div>
//               <div className="card-body px-2">
//                 <h5 className="card-title fw-semibold">{card.title}</h5>
//                 <p className="card-text text-muted small">{card.description}</p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default BootstrapCardGrid;
